import React, { useEffect, useState } from "react";
import { getVideoThumbnail } from "../../helpers/HelperFunctions.js";

const VideoThumbnail = ({ iframeSrc, alt = "Video thumbnail" }) => {
  const [thumbnailUrl, setThumbnailUrl] = useState(null);

  useEffect(() => {
    const fetchThumbnail = async () => {
      const url = await getVideoThumbnail(iframeSrc);
      setThumbnailUrl(url);
    };

    if (iframeSrc) {
      fetchThumbnail();
    }
  }, [iframeSrc]);

  if (!thumbnailUrl) return <div className="ou-video-thumbnail"><p style={{padding: 25, textAlign: 'center'}}>Loading thumbnail...</p></div>;

  return (
    <img className="ou-video-thumbnail" src={thumbnailUrl} alt={alt} />
  );
};

export default VideoThumbnail;
